import CustomSearchBar from "components/CustomSearchBar";
import moment from "moment";
import { useEffect, useState } from "react";
import ListViewContainer from "components/ListViewContainer";
import { useGetCBBOListQuery } from "features/onboarding/organizations/FarmersGroup/CBBO/CBBOApiSlice";
import LeadStatusTag from "features/onboarding/organizations/LeadStatusTag";
import useDebouncedValue from "hooks/useDebouncedValue";
const CbboProjectList = () => {
  const [users, setUsers] = useState([]);
  const [selectedCbbo, setSelectedCbbo] = useState({});
  const [pagination, setPagination] = useState({ page: 1, pageCount: 0 });
  const [cbboDetails, setCbboDetails] = useState({});
  const [searchKey, setSearchKey] = useState("");
  const debouncedSearch = useDebouncedValue(searchKey);
  const handleChangeSearch = (message) => {
    setSearchKey(message);
  };
  const { data: data, isLoading, refetch } = useGetCBBOListQuery({
    pagination,
    searchKey: debouncedSearch || "",
  });

  useEffect(() => {
    const dataFromApi = data?.data?.results
      ? data?.data?.results.filter((item) => item.project !== null)
      : [];
    const paginationFromApi = data?.data?.pages
      ? { page: data?.data?.current_page, pageCount: data?.data?.pages }
      : pagination;

    setUsers(dataFromApi);
    setPagination(paginationFromApi);
  }, [data]);

  const handleCheckboxChange = (event, row) => {
    let updatedSelection;
    setSelectedCbbo((prevSelected) => {
      updatedSelection = { ...prevSelected };
      if (event.target.checked) {
        updatedSelection[row.id] = row;
      } else {
        delete updatedSelection[row.id];
      }
      localStorage.setItem(
        "selectedCbbo",
        JSON.stringify(updatedSelection || {})
      );
      return updatedSelection;
    });
  };

  const LastSelected = JSON.parse(localStorage.getItem("selectedCbbo"));
  useEffect(() => {
    const savedCbbo = JSON.parse(localStorage.getItem("selectedCbbo")) || {};
    setCbboDetails(savedCbbo);
  }, [selectedCbbo]);

  const columns = [
    {
      field: "select Cbbo",
      headerName: "Select",
      width: 90,
      renderCell: (cellValues) => (
        <div>
          <input
            type="checkbox"
            checked={
              (selectedCbbo && !!selectedCbbo[cellValues?.row?.id]) ||
              (LastSelected && LastSelected[cellValues?.row?.id])
            }
            onChange={(e) => handleCheckboxChange(e, cellValues?.row)}
            className="mx-3 cursor"
          />
        </div>
      ),
    },
    {
      field: "created_at",
      headerName: "Created At",
      width: 100,
      type: "date",
      valueFormatter: (params) => moment(params?.value).format("DD/MM/YYYY "),
    },
    { field: "organization_name", headerName: "Organization ", width: 220 },
    { field: "phone_number", headerName: "Mobile", width: 120 },
    { field: "email", headerName: "Email", width: 170 },
    { field: "registration_number", headerName: "COI Number", width: 130 },
    {
      field: "implementation_agency",
      headerName: "Implementation Agency",
      width: 200,
    },
    { field: "land_holding", headerName: "Land Holding", width: 130 },
    {
      field: "current_status",
      headerName: "Current Status",
      width: 180,
      renderCell: (cellvalues) => {
        return (
          <LeadStatusTag
            statusVal={cellvalues?.row?.current_status.split("_").join(" ")}
          />
        );
      },
    },
  ];

  const tableData = {
    rows: users,
    columns: columns,
    paginationState: [pagination, setPagination],
    isLoading: isLoading,
  };

  return (
    <div className="mt-lg-0 mt-md-0 mt-3">
      <div className="searchboxtable d-flex justify-content-end align-items-center gap-3">
        <div className="my-lg-0 my-md-0 my-1">
          {" "}
          Total CBBO :
          <span className="text-success">&nbsp;{users?.length}</span>
        </div>
        <div className="">
          <CustomSearchBar sendSearchFunction={handleChangeSearch} />
        </div>
      </div>

      <div className="mt-lg-5 mt-md-3 mt-0">
        <ListViewContainer
          showHeaderSection={true}
          searchBar={true}
          tableData={{
            rows: tableData.rows,
            columns: tableData.columns,
            paginationState: [pagination, setPagination],
            isLoading: tableData.isLoading,
            checkboxShowFalse: true,
          }}
        />
      </div>
    </div>
  );
};

export default CbboProjectList;
